import useTranslation from 'next-translate/useTranslation';
import NextLink from 'next/link';

import { Icon, Link, SeeMore } from '@/atoms';
import { Card } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeMapCardProps } from './types';

/**
 * MapCard
 */
export const MapCard: FunctionComponent<TypeMapCardProps> = ({
  className = '',
  caption,
  servicios,
  transporte,
  itemsToShow,
  subtitle,
  title,
  orientation,
  mapIframe,
  numberOfElements,
  button,
}: TypeMapCardProps) => {
  const { t } = useTranslation('common');
  const itemsList = itemsToShow === 'transporte' ? transporte : servicios;

  return (
    <Card
      multimediaProps={{
        src: mapIframe,
        popUp: true,
        descPopUp: subtitle,
        popUpTitle: title,
      }}
      orientation={orientation}
      className={`bg-white  ${className}`}
    >
      <div
        className={`flex flex-col justify-around ${
          !button?.src && !button?.label ? 'min-h-[274px]' : ''
        }`}
      >
        <div className="flex flex-col gap-1 text-primary-400">
          {caption && (
            <span className="text-caption text-caption--small">{caption}</span>
          )}
          <h3 className="text-heading text-heading--h3">{title}</h3>
          {subtitle && (
            <span className="text-body text-body--secondary font-bold">
              {subtitle}
            </span>
          )}
        </div>
        <div
          className={`mb-2 mt-8 text-primary-400
          ${
            orientation === 'column'
              ? 'flex flex-col'
              : 'grid grid-cols-2 gap-4 '
          }`}
        >
          <SeeMore
            labels={{
              viewLess: t('components.atoms.seeMore.labels.viewLess'),
              viewMore: t('components.atoms.seeMore.labels.viewMore'),
            }}
            icon="ArrowDownPri"
            expanded={false}
            variant="primary"
            numberOfElements={numberOfElements}
          >
            {itemsList.map((element, index) => (
              <div key={index} className="flex flex-row items-center gap-2">
                {/** Cambiar como se reciben los iconos del back */}
                <Icon
                  className="text-primary-400"
                  height={16}
                  width={16}
                  src={element.icon}
                />
                <span className="text-body text-body--secondary ">
                  {element.text}
                </span>
              </div>
            ))}
          </SeeMore>
        </div>
      </div>
      {button?.label && button?.src && (
        <div className="pt-4">
          <NextLink href={button?.src} passHref prefetch={false}>
            <Link
              arrow={true}
              as="span"
              variant={button?.variant}
              className="flex w-full items-center justify-center"
            >
              {button?.label}
            </Link>
          </NextLink>
        </div>
      )}
    </Card>
  );
};

MapCard.displayName = 'MapCard';
